import AttachmentBrowser from './AttachmentBrowser.yaml?component';

export { AttachmentBrowser };
